<template>
  <el-dialog  :visible.sync="dialogVisible" class="w-100" top="40px">
    <el-row>
      <el-col :span="4" class="item-label">保单号</el-col>
      <el-col :span="8">
          <el-input v-model="biz_info.policy_number" @input="inputPolicyNumber" class="w-100" disabled></el-input>
      </el-col>
      <el-col :span="12">
        <el-input v-model="biz_info.policy_number" @input="inputPolicyNumber" placeholder="请输入" class="w-50"></el-input>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="4" class="item-label"><span class="hl-red">船名</span></el-col>
      <el-col :span="8">
          <el-input v-model="biz_info.ship_name" @input="inputShipName" class="w-100" ></el-input>
      </el-col>
      <el-col :span="6">
        <el-select v-model="objectValue" filterable remote reserve-keyword placeholder="请选择保险对象"
                   :remote-method="remoteInsuranceObjectSearch"
                   @change="handleInsuranceObjectChange"  class="w-100">
          <el-option v-for="object in objectOptions" :key="object.id" :label="object.name" :value="object.id">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="6">
          <el-radio-group v-model="objectTypeValue" >
            <el-radio v-for="type in objectTypeOptions" :label="type.code" :key="type.code">
              <span>{{ type.value }}</span>
            </el-radio>
          </el-radio-group>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="4" class="item-label"><span class="hl-red">投保人</span></el-col>
      <el-col :span="8">
        <el-input v-model="biz_info.applicant" @input="inputApplicant" class="w-100" ></el-input>
      </el-col>
      <el-col :span="12">
        <el-select placeholder="输入关键字后搜索并选择，或直接输入空格" filterable remote reserve-keyword class="w-50"
                   :remote-method="remoteSearchInsured" v-model="applicantValue" @change="handleSelectedApplicant">
          <el-option v-for="item in insuredOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="4" class="item-label"><span class="hl-red">被保险人</span></el-col>
      <el-col :span="8">
        <el-input v-model="biz_info.insured" @input="inputInsured" class="w-100" ></el-input>
      </el-col>
      <el-col :span="12">
        <el-select placeholder="输入关键字后搜索并选择，或直接输入空格" filterable remote reserve-keyword class="w-50"
                   :remote-method="remoteSearchInsured" v-model="insuredValue" @change="handleSelectedInsured">
          <el-option v-for="item in insuredOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="4" class="item-label"><span class="hl-red">生效日期</span></el-col>
      <el-col :span="8">
        <el-input v-model="biz_info.effective_date"  disabled></el-input>
      </el-col>
      <el-col :span="12">
        <el-date-picker v-model="biz_info.effective_date" type="date" value-format="yyyy-MM-dd"
                        placeholder="生效日期" @input="inputEffectiveDate" class="w-50"></el-date-picker>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="4" class="item-label"><span class="hl-red">到期日期</span></el-col>
      <el-col :span="8">
        <el-input v-model="biz_info.expiration_date"  disabled></el-input>
      </el-col>
      <el-col :span="12">
        <el-date-picker v-model="biz_info.expiration_date" type="date" value-format="yyyy-MM-dd"
                        placeholder="到期日期" @input="inputExpirationDate" class="w-50"></el-date-picker>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="4" class="item-label"><span class="hl-red">出单日期</span></el-col>
      <el-col :span="8">
          <el-input v-model="biz_info.issue_month"  disabled></el-input>
      </el-col>
      <el-col :span="12">
        <el-date-picker v-model="biz_info.issue_month"  type="date" value-format="yyyy-MM-dd"
                        placeholder="选择出单日期" @input="inputIssueMonth" class="w-50">
        </el-date-picker>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="4" class="item-label"><span class="hl-red">业务类型</span></el-col>
      <el-col :span="8">
          <el-input v-model="biz_info.business_type" @input="inputBusinessType" :disabled="disabled"></el-input>
      </el-col>
      <el-col :span="12">
        <el-select v-model="biz_info.business_type" @change="inputBusinessType" placeholder="请输入业务类型" class="w-50">
          <el-option v-for="(item, index) in business_type_list" :key="index" :label="item.value" :value="item.value">
          </el-option>
        </el-select>
      </el-col>
    </el-row>

<!--    <el-row>-->
<!--      <el-col :span="4" class="item-label">保费</el-col>-->
<!--      <el-col :span="8">-->
<!--        <el-input v-model="biz_info.premium" @input="inputPremium" class="w-100" disabled></el-input>-->
<!--      </el-col>-->
<!--      <el-col :span="12">-->
<!--        <el-input v-model="biz_info.premium" @input="inputPremium" placeholder="请输入" class="w-50"></el-input>-->
<!--      </el-col>-->
<!--    </el-row>-->
  </el-dialog>
</template>

<script>
import {fetchDictList, searchInsuranceObjectList} from "@/api/common";
import {fetchCustomerList} from "@/api/customer";
export default {
  name: 'biz-info-input',
  props: {
    is_disabled:{
      default:true
    },
    policy_number:{
      default:''
    },
    ship_name:{
      default:''
    },
    applicant:{
      default:''
    },
    insured:{
      default:''
    },
    effective_date:{
      default:''
    },
    expiration_date:{
      default:''
    },
    issue_month:{
      default:''
    },
    business_type:{
      default:''
    },
    premium:{
      default:0
    },
  },
  data() {
    return {
      dialogVisible: false,
      disabled: this.is_disabled,
      // 业务关系类型选项
      objectTypeOptions:[],
      objectTypeValue: null,
      objectOptionsCache:{},
      // 保险对象选项
      objectOptions:[],
      objectValue:'',

      // 被保险人选项
      insuredOptions:[],
      insuredValue: null,
      // 投保人选项
      applicantValue: null,

      // 业务类型选项
      business_type_list: [],

      biz_info: {
        policy_number: this.policy_number,
        ship_name: this.ship_name,
        applicant: this.applicant,
        insured: this.insured,
        effective_date: this.effective_date,
        expiration_date: this.expiration_date,
        issue_month: this.issue_month,
        business_type: this.business_type,
        premium: this.premium,
      },
    }
  },
  watch: {
    'is_disabled': function (val){
      this.disabled = val
    },
    'policy_number': function(val){
      this.biz_info.policy_number = val
    },
    'ship_name': function(val){
      this.biz_info.ship_name = val
    },
    'insured': function(val){
      this.biz_info.insured = val
    },
    'applicant': function(val){
      this.biz_info.applicant = val
    },
    'effective_date': function(val){
      this.biz_info.effective_date = val
    },
    'expiration_date': function(val){
      this.biz_info.expiration_date = val
    },
    'issue_month': function(val){
      this.biz_info.issue_month = val
    },
    'business_type': function(val){
      this.biz_info.business_type = val
    },
    'premium': function(val){
      this.biz_info.premium = val
    },
  },
  methods:{
    showDialog(){
      this.dialogVisible = true
    },
    loadData(){
      let p = []
      p.push(fetchDictList({type: "insurance_type.object_type"}))
      p.push(fetchDictList({type: 'insurance.business_type'}))
      Promise.all(p).then(resp => {
        // 获取业务对象选项
        this.objectTypeOptions = resp[0]
        if(Array.isArray(this.objectTypeOptions)){
          if(this.objectTypeOptions.length > 0){
            this.objectTypeValue = this.objectTypeOptions[0].code
          }
        }
        // 获取业务类型选项
        this.business_type_list = resp[1]
      })
    },
    // 更换业务对象
    handleInsuranceObjectChange(value){
      let selectedItem = this.objectOptions.find(item => {
        return(item.id === parseInt(value))
      })
      if(selectedItem) {
        this.biz_info.ship_name = selectedItem.name
        this.inputShipName(this.biz_info.ship_name)
      } else {
        this.$message.error("选择业务对象出错")
      }
    },
    // 搜索保险业务对象
    remoteInsuranceObjectSearch(search){
      if (search !== ''){
        searchInsuranceObjectList(this.objectTypeValue, search)
            .then(resp => {
              this.objectOptions = resp
            })
            .catch(error => {
              this.$error_message(error)
            })
      }else{
        this.objectOptions = []
      }
    },

    // 搜索并获取被保险人
    remoteSearchInsured(search) {
      if (search !== '') {
        // this.loading = true
        fetchCustomerList({search: search})
            .then(res => {
              this.insuredOptions = Object.assign([], res)
              // this.loading = false
            })
            .catch(error => {
              // this.loading = false
              this.$error_message(error)
            })
      } else {
        this.insuredOptions = []
      }
    },
    // 获取所选择的被保险人
    handleSelectedInsured(value){
      let selectedItem = this.insuredOptions.find(item => {
        return(item.id === parseInt(value))
      })
      if(selectedItem) {
        this.biz_info.insured = selectedItem.name
        this.inputInsured(this.biz_info.insured)
      } else {
        this.$message.error("选择出错")
      }
    },
    // 获取所选择的投保人
    handleSelectedApplicant(value){
      let selectedItem = this.insuredOptions.find(item => {
        return(item.id === parseInt(value))
      })
      if(selectedItem) {
        this.biz_info.applicant = selectedItem.name
        this.inputApplicant(this.biz_info.applicant)
      } else {
        this.$message.error("选择出错")
      }
      // this.biz_info.applicant = value.join(',')
      // this.inputApplicant(this.biz_info.applicant)
    },

    emitUpdate(){
      this.$emit('change', this.biz_info)
    },
    inputPolicyNumber(val){
      this.biz_info.policy_number = val
      this.emitUpdate()
    },
    inputShipName(val){
      this.biz_info.ship_name = val
      this.emitUpdate()
    },
    inputApplicant(val){
      this.biz_info.applicant = val
      this.emitUpdate()
    },
    inputInsured(val){
      this.biz_info.insured = val
      this.emitUpdate()
    },
    inputEffectiveDate(val){
      this.biz_info.effective_date = val
      this.emitUpdate()
    },
    inputExpirationDate(val){
      this.biz_info.expiration_date = val
      this.emitUpdate()
    },
    inputIssueMonth(val){
      this.biz_info.issue_month = val
      this.emitUpdate()
    },
    inputBusinessType(val){
      this.biz_info.business_type = val
      this.emitUpdate()
    },
    inputPremium (val){
      this.biz_info.premium = val
      this.emitUpdate()
    },
    validate(){
      let result = []
      if(this.biz_info.ship_name === '' || this.biz_info.ship_name === null) result.push('船名')
      if(this.biz_info.applicant === '' || this.biz_info.applicant === null) result.push('投保人')
      if(this.biz_info.insured === '' || this.biz_info.insured === null) result.push('被保险人')
      if(this.biz_info.effective_date === '' || this.biz_info.effective_date === null ) result.push('生效日期')
      if(this.biz_info.expiration_date === '' || this.biz_info.expiration_date === null) result.push('到期日期')
      if(this.biz_info.issue_month === '' || this.biz_info.issue_month === null) result.push('出单月份')
      if(this.biz_info.business_type === '' || this.biz_info.business_type === null) result.push('业务类型')
      return result
    }
  },
  created() {
    this.loadData()
  }
}

</script>

<style scoped>
.item-label {
  text-align: right;
  vertical-align: middle;
  float: left;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
  padding: 0 12px 0 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.hl-red {
  color: red;
}

>>> .el-dialog {
  width:96%
}

>>> .el-radio-group{
  margin: 10px;
}
</style>
